import util from '../util'

let controller = 'CessaoBoleto'
export default {
    GetAll: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
    },
    Cancelar: function (dto) {
      return util.Axios.Post(controller +'/Cancelar', dto)
    }, 
    Historico(id){
      return util.Axios.Get(controller + '/Historico', id)
    }
  }
  